
const AUTH_ERROR_TRANSLATIONS = {
    USER_LOCKED: 'Аккаунт временно заблокирован. Попробуйте позже или обратитесь к администратору.',
    BAD_CREDENTIALS: 'Неверное имя пользователя или пароль',
    USER_DISABLED: 'Аккаунт отключён. Обратитесь к администратору.',
};


export function getBackendErrorMessage(error, defaultMessage = 'Произошла ошибка. Попробуйте позже.') {
    if (!error || typeof error !== 'object') return defaultMessage;

    const { code, message, status } = error;

    if (code && AUTH_ERROR_TRANSLATIONS[code]) {
        return AUTH_ERROR_TRANSLATIONS[code];
    }

    if (typeof message === 'string' && message.trim().length > 0) {
        return message;
    }

    if (status === 401) {
        return 'Неверное имя пользователя или пароль';
    }

    if (status === 403) {
        return 'Доступ запрещён.';
    }

    if (status >= 500) {
        return 'На сервере произошла ошибка. Попробуйте позже.';
    }

    return defaultMessage;
}